import { Badge, Box, Grid, Group, UnstyledButton } from "@mantine/core";
import { IconUserCircle } from "@tabler/icons-react";
import { Text, Title } from "components";
import { TFunction } from "i18next";
import moment from "moment";
import { useMemo } from "react";
import { ChatResponse } from "types";

interface ChatUserItemProps {
  item: ChatResponse;
  index: number;
  t: TFunction;
  activeChat: ChatResponse | undefined;
  setActiveChat: (item: ChatResponse) => void;
}

const ChatUserItem = ({ item, index, t, activeChat, setActiveChat }: ChatUserItemProps) => {

  const lastMessageCreatedAt = useMemo(() => {
    if (!item.lastMessage) {
      return '';
    }
    const createdAt = new Date(item.lastMessage.createdAt);
    const diff = moment(new Date()).diff(createdAt, 'days');
    if (diff === 0) return t('format.time', { date: createdAt})
    if (diff === 1) return t('format.day.yesterday') + ' ' + t('format.time', { date: createdAt})
    if (diff < 7) {
      const day = moment(createdAt).day();
      return t('format.day.' + day) + ' ' + t('format.time', { date: createdAt});
    }
    return t('format.date', { date: createdAt }) + t('format.time', { date: createdAt })
  }, [item]);

  return (
    <UnstyledButton
      key={`chat-user-${index}`}
      w={'100%'}
      h={64}
      onClick={() => setActiveChat(item)}
      bg={activeChat?.id === item.id ? 'var(--mantine-color-gray-4)' : 'transparent'}
      pt={6}
      pl={'md'}
      pr={'lg'}
    >
      <Group gap={0} wrap={'nowrap'}>
        <Box visibleFrom={'md'}>
          <IconUserCircle stroke={1} size={48} />
        </Box>
        <Box style={{ flexGrow: 1}} mx={'md'} mb={4}>
          <Grid>
            <Grid.Col span={{ xs: 12, sm: 12, md: 8 }} p={0} >
              <Title order={6} mb={0} mt={0}>{item.user.fullName}</Title>
            </Grid.Col>
            <Grid.Col span={{ xs: 0, sm: 0, md: 4 }} visibleFrom={'md'} p={0}>
              <Text ta={'right'} size={'sm'}>{lastMessageCreatedAt}</Text>
            </Grid.Col>
          </Grid>
          <Grid pt={12}>
            <Grid.Col span={9} p={0}>
              <Text truncate={false} lineClamp={1}>{item.lastMessage ? item.lastMessage.message : ''}</Text>
            </Grid.Col>
            <Grid.Col span={3} p={0}>
              {item.unread ? <Badge circle={true} style={{ float: 'right' }} size={'md'}>{item.unread}</Badge> : <></>}
            </Grid.Col>
          </Grid>
        </Box>
      </Group>
    </UnstyledButton>
  );
}

export default ChatUserItem;